<form #step4Form="ngForm" class="editForm customMat" validate>
    <div class="tab-pane fade in active">
        <div class="flex-center">
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step4Form);$event.preventDefault();">< zurück</button>
            <h4 class="sub">{{title}}</h4>
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="next" [disabled]="!step4Form.valid" (click)="goToNext(step4Form);$event.preventDefault();">weiter ></button>
        </div>
        <div class='row'>
            <div class='col-xs-offset-1 col-xs-10'>
                <div class="row flex-strech">
                    <div class='col-xs-12 col-sm-6'>
                        <div class="item">

                            <div class="flex-space-between">
                                <div>
                                    <img src="assets/images/icon_ort.png" class="box-image" />
                                    <p class="sub">Wo befindet sich Ihre Immobilie</p>
                                </div>
                                <div>
                                    <div class="row">
                                        <mat-card>
                                            <mat-card-content>
                                              <mat-google-maps-autocomplete
                                              country="de"
                                              [types]="types"
                                              [strictBounds]="strictBounds"
                                              [addressLabelText]="addressLabelText"
                                              (onAutocompleteSelected)="onAutocompleteSelected($event)">
                                              </mat-google-maps-autocomplete>
                                              <mat-icon color="primary" style="position: absolute;right:20px;top:35px;background: white;width: 60px;height: 50px;" class="mat-icon notranslate mat-primary material-icons ng-tns-c62-9" matSuffix>search</mat-icon>
                                              </mat-card-content>
                                        </mat-card>
                                    </div>
                                    
                                    <div class="row no-gutter">
                                      <div class='col-xs-12 col-sm-8'>
                                          <mat-form-field class="margin-10-desktop">
                                            <mat-label>Straße</mat-label>
                                            <input
                                              [(ngModel)]="step4.address"
                                              name="address"
                                              matInput
                                              required
                                            />
                                        </mat-form-field>
                                    </div> 
                                    <div class='col-xs-12 col-sm-4'>
                                        <mat-form-field>
                                          <mat-label>Hausnr.</mat-label>
                                          <input
                                            [(ngModel)]="step4.address2"
                                            name="address2"
                                            matInput
                                            required
                                          />
                                        </mat-form-field>
                                      </div>
                                    
                                      <div class='col-xs-12 col-sm-4'>
                                        <mat-form-field class="margin-10-desktop">
                                          <mat-label>Postleitzahl</mat-label>
                                          <input
                                            [(ngModel)]="step4.postalcode"
                                            name="postelcode"
                                            matInput
                                            required
                                          />
                                        </mat-form-field>
                                      </div>
                                      <div class='col-xs-12 col-sm-8'>
                                          <mat-form-field>
                                            <mat-label>Ort</mat-label>
                                            <input
                                              [(ngModel)]="step4.city"
                                              name="city"
                                              #locality
                                              matInput
                                              required
                                            />
                                            <mat-icon color="primary" matSuffix style="position: absolute;right:0;top:-25px;background:#fff;width: 30px;" matSuffix class="mat-primary notranslate material-icons mat-icon">add_location</mat-icon>
                                          </mat-form-field>
                                    </div>
                                  </div>

                                    <!-- Edit End -->

                                    <div class='col-12' style="font-size: 1.2em;
                                    color: #999;
                                    margin: 0 0 1.5em 0; text-align: left;">
                                        <span>Selbst in der gleichen Straße können m<sup>2</sup> Preise sehr unterschiedlich sein. Bitte geben Sie daher unbedingt die vollständige Adresse inklusive Hausnummer an.</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class='col-xs-12 col-sm-6'>
                        <div class="item">

                            <div class="flex-space-between">
                                <div>
                                    <img src="assets/images/icon_zustand.png" class="box-image" />
                                    <p class="sub">Immobilienwert in € (geschätzt)
                                        <br />
                                    <span style="font-size:0.7em; color: #999;">(optional)</span></p>
                                </div>
                                <div> 
                                  <div [formGroup]="testForm">
                                        <mat-form-field class="example-form-field">
                                            <mat-label>Immobilienwert</mat-label>
                                             <input matInput class="larger-text" type="number"  pattern="[0-9]*" #price [(ngModel)]="step4.price" name="price" #price formControlName="price" maxlength="5" >
                                            <div class="custom-suffix max-width-80-percent" [style.width.px] = "50 + ( 13 * price.value.length)">
                                              <span matSuffix>€</span>
                                          </div>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                    
            </div>
        </div>
        <div class="flex-center">
          <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step4Form);$event.preventDefault();">< zurück</button>
          <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="next" [disabled]="!step4Form.valid" (click)="goToNext(step4Form);$event.preventDefault();">weiter ></button>
      </div>
    </div>
</form>
  <app-footer [progress]="80"></app-footer>